(function () {
  var root = document.getElementById('cg-turn-four');
  if (!root) return;

  var search = document.getElementById('cg-search');
  var result = document.getElementById('cg-result-count');

  var drivers = Array.prototype.slice.call(
    root.querySelectorAll('.cg-driver')
  );

  var filterButtons = Array.prototype.slice.call(
    root.querySelectorAll('.cg-filter')
  );

  function clean(text) {
    return String(text || '')
      .toLowerCase()
      .trim();
  }

  /*
   * RESTORE THE ENTIRE CHECKLIST
   */
  function showEverything() {
    drivers.forEach(function (driver) {
      driver.style.display = '';

      driver.querySelectorAll('.cg-card-group').forEach(
        function (group) {
          group.style.display = '';
        }
      );

      driver.querySelectorAll('.cg-card-row').forEach(
        function (row) {
          row.style.display = '';
        }
      );
    });

    root.querySelectorAll('[data-driver-link]').forEach(
      function (link) {
        link.style.display = '';
      }
    );
  }

  /*
   * SMOOTH SCROLL
   */
  function jumpTo(target) {
    if (!target) return;

    showEverything();

    setTimeout(function () {
      var y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        130;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });

      target.style.outline =
        '3px solid #f1b82d';

      target.style.outlineOffset =
        '6px';

      setTimeout(function () {
        target.style.outline = '';
        target.style.outlineOffset = '';
      }, 2000);

    }, 50);
  }

  /*
   * SEARCH
   *
   * Type driver/set/card then press ENTER.
   */
  if (search) {
    search.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        var query = clean(search.value);

        if (!query) {
          showEverything();

          if (result) {
            result.textContent =
              'Showing all checklist entries.';
          }

          return;
        }

        showEverything();

        /*
         * FIRST: exact/partial driver match
         */
        var match = drivers.find(
          function (driver) {
            var driverName = clean(
              driver.getAttribute('data-driver')
            );

            return (
              driverName === query ||
              driverName.indexOf(query) !== -1
            );
          }
        );

        /*
         * SECOND: match any card/set inside driver
         */
        if (!match) {
          match = drivers.find(
            function (driver) {
              return clean(
                driver.textContent
              ).indexOf(query) !== -1;
            }
          );
        }

        if (match) {
          var name =
            match.getAttribute('data-driver') ||
            'matching driver';

          if (result) {
            result.textContent =
              'Found ' +
              name +
              ' — jumping to checklist.';
          }

          jumpTo(match);

        } else {
          if (result) {
            result.textContent =
              'No matching driver, set or card found.';
          }
        }
      }
    );
  }

  /*
   * FILTER CHECKLIST
   */
  function applyFilter(filter) {

    showEverything();

    if (filter === 'all') {

      if (result) {
        result.textContent =
          'Showing all checklist entries.';
      }

      return;
    }

    var totalRows = 0;
    var totalDrivers = 0;

    drivers.forEach(function (driver) {

      var rows = Array.prototype.slice.call(
        driver.querySelectorAll(
          '.cg-card-row'
        )
      );

      var visibleRows = 0;

      /*
       * Rookie detection
       */
      var driverIsRookie =
        !!driver.querySelector(
          '.cg-badge-rc'
        ) ||
        clean(
          driver.querySelector('h3')
            ? driver.querySelector('h3').textContent
            : ''
        ).indexOf('rc') !== -1;

      rows.forEach(function (row) {

        var text = clean(
          (
            row.getAttribute(
              'data-search'
            ) || ''
          ) +
          ' ' +
          row.textContent
        );

        var category = clean(
          row.getAttribute(
            'data-category'
          )
        );

        var show = false;

        /*
         * ROOKIES
         */
        if (filter === 'rookies') {
          show = driverIsRookie;
        }

        /*
         * AUTOGRAPHS
         */
        else if (filter === 'auto') {
          show =
            category === 'auto' ||
            !!row.querySelector(
              '.cg-badge-auto'
            ) ||
            text.indexOf(
              'autograph'
            ) !== -1 ||
            text.indexOf(
              'signatures'
            ) !== -1;
        }

        /*
         * MEMORABILIA
         */
        else if (filter === 'mem') {
          show =
            category === 'mem' ||
            !!row.querySelector(
              '.cg-badge-mem'
            ) ||
            text.indexOf(
              'memorabilia'
            ) !== -1 ||
            text.indexOf(
              'swatch'
            ) !== -1 ||
            text.indexOf(
              'patch'
            ) !== -1;
        }

        /*
         * FOTL BLACK /6
         */
        else if (filter === 'fotl') {
          show =
            !!row.querySelector(
              '.cg-badge-fotl'
            ) ||
            text.indexOf(
              'black fotl'
            ) !== -1;
        }

        /*
         * KA-VROOM!
         */
        else if (
          filter === 'kavroom'
        ) {
          show =
            category === 'kavroom' ||
            text.indexOf(
              'ka-vroom'
            ) !== -1 ||
            text.indexOf(
              'kavroom'
            ) !== -1;
        }

        if (show) {
          row.style.display = '';
          visibleRows++;
          totalRows++;
        } else {
          row.style.display = 'none';
        }
      });

      /*
       * Hide empty card groups
       */
      driver
        .querySelectorAll(
          '.cg-card-group'
        )
        .forEach(
          function (group) {

            var groupRows =
              Array.prototype.slice.call(
                group.querySelectorAll(
                  '.cg-card-row'
                )
              );

            var hasVisible =
              groupRows.some(
                function (row) {
                  return (
                    row.style.display !==
                    'none'
                  );
                }
              );

            group.style.display =
              hasVisible
                ? ''
                : 'none';
          }
        );

      /*
       * Hide driver if nothing matches
       */
      if (visibleRows === 0) {
        driver.style.display =
          'none';
      } else {
        driver.style.display = '';
        totalDrivers++;
      }
    });

    /*
     * Hide driver index while filtering.
     * This prevents links to hidden drivers
     * from becoming confusing.
     */
    var index =
      document.getElementById(
        'cg-driver-index'
      );

    if (index) {
      index.style.display =
        filter === 'all'
          ? ''
          : 'none';
    }

    if (result) {
      result.textContent =
        'Showing ' +
        totalRows.toLocaleString() +
        ' matching checklist entries across ' +
        totalDrivers.toLocaleString() +
        ' drivers.';
    }
  }

  /*
   * FILTER BUTTON CLICKS
   *
   * Event delegation is more reliable
   * inside Shopify article content.
   */
  root.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '.cg-filter'
        );

      if (!button) return;

      event.preventDefault();

      filterButtons.forEach(
        function (btn) {
          btn.classList.remove(
            'is-active'
          );
        }
      );

      button.classList.add(
        'is-active'
      );

      var filter =
        button.getAttribute(
          'data-filter'
        ) || 'all';

      applyFilter(filter);
    }
  );

  /*
   * ALL INTERNAL CHECKLIST LINKS
   *
   * Driver index
   * Ka-Vroom links
   * Rookie links
   * Top drivers
   * Back to drivers
   * Quick navigation
   */
  root.addEventListener(
    'click',
    function (event) {

      var link =
        event.target.closest(
          'a[href^="#"]'
        );

      if (!link) return;

      var href =
        link.getAttribute('href');

      if (
        !href ||
        href === '#'
      ) {
        return;
      }

      var id =
        href.substring(1);

      var target =
        document.getElementById(id);

      if (!target) return;

      event.preventDefault();

      /*
       * Reset filter state
       */
      filterButtons.forEach(
        function (btn) {
          btn.classList.toggle(
            'is-active',
            btn.getAttribute(
              'data-filter'
            ) === 'all'
          );
        }
      );

      var index =
        document.getElementById(
          'cg-driver-index'
        );

      if (index) {
        index.style.display = '';
      }

      showEverything();

      jumpTo(target);

      try {
        history.replaceState(
          null,
          '',
          href
        );
      } catch (e) {}
    }
  );

  /*
   * INITIAL STATE
   */
  showEverything();

})();